export default function () {
  return [
    { key: 'id', label: "id" },
    { key: 'name', label: "name" },
    { key: 'accountId', label: "accountId" },
    { key: 'usageType', label: "usageType" },
    { key: 'status', label: "status", type: 'status', selectProps: { clearable: true, multiple: false } },
    { key: 'notes', label: "notes" },
    { key: 'campaignType', label: "campaignType" },
  ]
}
